import { useTranslation } from 'react-i18next'
import { RotateCcw, ZoomIn, ZoomOut } from 'lucide-react'
import { Button } from '@/components/ui/button'
import type { TextZoom } from './useTextZoom'

/** Zoom out / percentage / zoom in / reset, for the text renderers' toolbar. */
export function TextZoomControls({ zoom }: { zoom: TextZoom }) {
  const { t } = useTranslation()
  return (
    <span className="flex flex-shrink-0 items-center gap-0.5">
      <Button
        variant="ghost"
        size="icon"
        className="h-7 w-7"
        disabled={!zoom.canZoomOut}
        onClick={zoom.zoomOut}
        title={t('common.zoomOut')}
        aria-label={t('common.zoomOut')}
      >
        <ZoomOut className="h-3.5 w-3.5" />
      </Button>
      <span className="w-9 text-center text-[11px] tabular-nums text-[var(--text-secondary)]">
        {Math.round(zoom.zoom * 100)}%
      </span>
      <Button
        variant="ghost"
        size="icon"
        className="h-7 w-7"
        disabled={!zoom.canZoomIn}
        onClick={zoom.zoomIn}
        title={t('common.zoomIn')}
        aria-label={t('common.zoomIn')}
      >
        <ZoomIn className="h-3.5 w-3.5" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className="h-7 w-7"
        disabled={zoom.zoom === 1}
        onClick={zoom.reset}
        title={t('common.zoomReset')}
        aria-label={t('common.zoomReset')}
      >
        <RotateCcw className="h-3.5 w-3.5" />
      </Button>
    </span>
  )
}
